import { compose, withPropsOnChange } from "recompose"
import { getTechCard } from "../api/entities/techCard"
import apiTransport from "../api/apiTransport"

const withTechCard = compose(
  withPropsOnChange([`sapIssueId`], ({ sapIssueId }) => ({
    payload: sapIssueId,
    load: getTechCard,
    propName: `techCard`,
  })),
  apiTransport,
)

export default withTechCard
